import { defaultIconProps, IconProps } from './IconProps';

export const IconBracketsDots: import('react').FC<IconProps> = ({ size = 20, color, ...rest }) => {
  return (
    <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
      <path
        d="M15.476 16.6666C16.5277 16.6666 17.381 15.8141 17.381 14.7616V10.9524L18.3335 9.99992L17.381 9.04742V5.23825C17.381 4.18575 16.5285 3.33325 15.476 3.33325M4.52449 3.33325C3.47199 3.33325 2.61949 4.18575 2.61949 5.23825V9.04742L1.66699 9.99992L2.61949 10.9524V14.7616C2.61949 15.8141 3.47199 16.6666 4.52449 16.6666M6.25033 9.99992H6.25866M10.0003 9.99992H10.0087M13.7503 9.99992H13.7587M6.66699 9.99992C6.66699 10.23 6.48044 10.4166 6.25033 10.4166C6.02021 10.4166 5.83366 10.23 5.83366 9.99992C5.83366 9.7698 6.02021 9.58325 6.25033 9.58325C6.48044 9.58325 6.66699 9.7698 6.66699 9.99992ZM10.417 9.99992C10.417 10.23 10.2304 10.4166 10.0003 10.4166C9.77021 10.4166 9.58366 10.23 9.58366 9.99992C9.58366 9.7698 9.77021 9.58325 10.0003 9.58325C10.2304 9.58325 10.417 9.7698 10.417 9.99992ZM14.167 9.99992C14.167 10.23 13.9804 10.4166 13.7503 10.4166C13.5202 10.4166 13.3337 10.23 13.3337 9.99992C13.3337 9.7698 13.5202 9.58325 13.7503 9.58325C13.9804 9.58325 14.167 9.7698 14.167 9.99992Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

IconBracketsDots.defaultProps = defaultIconProps;
